const enum Folders {
  BANKING = "Banking",
  COMPLIANCE = "Compliance",
  CREDENTIALING = "Physician Credentialing",
  GENERAL = "General",
  INCOME = "Income",
  INSURANCE = "Insurance",
  INVESTMENTS = "Investments",
  PLANS = "Plans and proposals",
  PRIVATE = "Private",
  REAL_ESTATE = "Real Estate",
  TAX = "Tax Planning",
  TRUSTS = "Trusts and Estates",
  BUSINESS = "Business & Entrepreneurship",
  DEBTS_AND_LIABILITIES = "Debts & Liabilities",
  LIFE_GOALS = "Life Goals & Celebrations",
  WORKPLACE_BENEFITS = "Workplace Benefits",
}

export { Folders };
